import type { Product } from '@gozoki/api-types'
import { gozokiApi, gozokiApiWithAuth } from '../gozokiApi'

// Fetch one product
export const fetchProduct = async (id: number) => {
  const response = await gozokiApi.get<Product>(`/products/${id}`)
  return response.data
}

// Fetch all products
export const fetchProducts = async () => {
  const response = await gozokiApi.get<Product[]>('/products')
  return response.data
}

export const fetchProductsXlsx = async () => {
  const response = await gozokiApiWithAuth.get<Blob>('/products/export-xlsx', {
    responseType: 'blob',
  })

  return response.data
}
